import { createRouter, createWebHistory } from 'vue-router';
import CareersListPage from "./CareersListPage.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.careers-list-page', CareersListPage, {
  jsonProps: ['openPositions', 'countries', 'jobFamilies', 'cities'],
  beforeMount: (el, props) => { },
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});
